/**
 * Verplicht akkoord met de algemene voorwaarden en het verzendbeleid, zonder externe app.
 *
 * Het vinkje (snippet `terms-agreement`) staat in de winkelwagen en het winkelwagenpaneel.
 * De afrekenpagina zelf is zonder Shopify Plus niet aan te passen, dus dit script bewaakt de
 * knoppen die daarheen leiden:
 *
 *   1. de afrekenknop: een klik zonder vinkje wordt tegengehouden, met een melding bij het
 *      vinkje;
 *   2. de snelle betaalknoppen (Shop Pay, PayPal, Apple Pay, Google Pay): die versturen het
 *      formulier niet maar lezen de winkelwagen direct, dus ze blijven op slot tot het akkoord
 *      in de winkelwagen is opgeslagen. Een doorzichtige knop erover vangt de klik op.
 *
 * Het akkoord wordt met datum en tijd als winkelwagenkenmerk opgeslagen en komt zo bij de
 * bestelling in het beheer te staan. De afrekenknop stuurt het vinkje daarnaast zelf mee in
 * het formulier, zodat een klik vlak na het aanvinken nooit zonder akkoord aankomt.
 *
 * De "Direct kopen"-knop op productpagina's slaat de winkelwagen over en wordt daarom niet
 * getoond zolang deze functie aan staat (main-product-blocks, product-form en sticky-atc).
 */
(function () {
  'use strict';

  var configElement = document.querySelector('[data-terms-agreement-config]');
  if (!configElement) return;

  var CONFIG;
  try {
    CONFIG = JSON.parse(configElement.textContent);
  } catch (error) {
    return;
  }

  var SCOPE = '[data-ss-terms-scope]';
  var CONTAINER = '[data-ss-terms]';
  var CHECKBOX = '[data-ss-terms-checkbox]';
  var GATE = '[data-ss-terms-gate]';
  var SHIELD = '[data-ss-terms-shield]';
  var INVALID_CLASS = 'ss-terms--invalid';
  var SHAKE_CLASS = 'ss-terms--shake';

  /* De laatste keuze van de klant op deze pagina: { agreed, value, saved }. Tot de eerste klik
     is dat null, want dan klopt wat de server rendert al: dat komt uit het opgeslagen kenmerk. */
  var state = null;
  var latestRequest = 0;

  function closest(node, selector) {
    return node && node.closest ? node.closest(selector) : null;
  }

  function each(selector, callback) {
    Array.prototype.forEach.call(document.querySelectorAll(selector), callback);
  }

  /* "attributes[Akkoord voorwaarden]" wordt "Akkoord voorwaarden". De naam staat zo op één
     plek, in de snippet. */
  function attributeKey(checkbox) {
    var match = /^attributes\[(.+)\]$/.exec(checkbox.name || '');
    return match ? match[1] : null;
  }

  /* "Ja, aangevinkt op 28-09-2026 om 14:32", in Nederlandse tijd, zoals in het beheer. */
  function stamp() {
    try {
      var parts = {};
      new Intl.DateTimeFormat('nl-NL', {
        timeZone: 'Europe/Amsterdam',
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hourCycle: 'h23'
      })
        .formatToParts(new Date())
        .forEach(function (part) {
          parts[part.type] = part.value;
        });

      return (
        'Ja, aangevinkt op ' + parts.day + '-' + parts.month + '-' + parts.year + ' om ' + parts.hour + ':' + parts.minute
      );
    } catch (error) {
      return 'Ja';
    }
  }

  function lockGates(locked) {
    each(GATE, function (gate) {
      gate.toggleAttribute('data-locked', locked);

      var buttons = gate.querySelector('.ss-terms-gate__buttons');
      if (buttons) buttons.toggleAttribute('inert', locked);

      var shield = gate.querySelector(SHIELD);
      if (shield) shield.hidden = !locked;
    });
  }

  function clearReminders() {
    each(CONTAINER, function (container) {
      container.classList.remove(INVALID_CLASS, SHAKE_CLASS);
      var message = container.querySelector('.ss-terms__message');
      if (message) message.textContent = '';
    });
  }

  /* Zet alle vinkjes en slotjes op de pagina gelijk aan de laatste keuze. De betaalknoppen gaan
     pas open als het akkoord ook echt in de winkelwagen staat. */
  function apply() {
    if (!state) return;

    each(CHECKBOX, function (checkbox) {
      checkbox.checked = state.agreed;
      if (state.agreed) checkbox.value = state.value;
    });

    if (state.agreed) clearReminders();
    lockGates(!(state.agreed && state.saved));
  }

  function inView(element) {
    var rect = element.getBoundingClientRect();
    var height = window.innerHeight || document.documentElement.clientHeight;
    return rect.top >= 0 && rect.bottom <= height;
  }

  function remind(container, text) {
    var message = container.querySelector('.ss-terms__message');
    var checkbox = container.querySelector(CHECKBOX);

    container.classList.add(INVALID_CLASS);
    container.classList.remove(SHAKE_CLASS);
    void container.offsetWidth; // laat de animatie opnieuw beginnen
    container.classList.add(SHAKE_CLASS);

    /* Eerst leegmaken, zodat een schermlezer dezelfde melding bij een tweede klik opnieuw
       voorleest. */
    if (message) {
      message.textContent = '';
      window.requestAnimationFrame(function () {
        message.textContent = text;
      });
    }

    if (!inView(container)) container.scrollIntoView({ block: 'center', behavior: 'smooth' });
    if (checkbox) checkbox.focus({ preventScroll: true });
  }

  function remindAll(text) {
    each(CONTAINER, function (container) {
      remind(container, text);
    });
  }

  function save(key) {
    var requestId = ++latestRequest;
    var value = state.agreed ? state.value : '';
    var attributes = {};
    attributes[key] = value; // een lege waarde haalt het kenmerk weg

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    fetch(root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: attributes })
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Status ' + response.status);
        return response.json();
      })
      .then(function (cart) {
        if (requestId !== latestRequest) return;

        var stored = (cart && cart.attributes && cart.attributes[key]) || '';
        if (stored !== value) throw new Error('Kenmerk niet opgeslagen');

        state.saved = true;
        apply();
      })
      .catch(function () {
        if (requestId !== latestRequest) return;

        /* Uitvinken dat niet opgeslagen werd, laat alles op slot: dat is de veilige kant. */
        if (!state.agreed) return;

        state = { agreed: false, value: '', saved: false };
        apply();
        remindAll(CONFIG.messages.saveError);
      });
  }

  document.addEventListener('change', function (event) {
    var checkbox = event.target;
    if (!checkbox || !checkbox.matches || !checkbox.matches(CHECKBOX)) return;

    var key = attributeKey(checkbox);
    if (!key) return;

    state = { agreed: checkbox.checked, value: checkbox.checked ? stamp() : '', saved: false };
    apply();
    save(key);
  });

  function guard(event, trigger) {
    var scope = closest(trigger, SCOPE);
    var container = scope && scope.querySelector(CONTAINER);
    var checkbox = container && container.querySelector(CHECKBOX);
    if (!checkbox) return;

    var isShield = trigger.matches(SHIELD);
    if (checkbox.checked && !isShield) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    /* Een klik op het slotje terwijl het vinkje al aan staat: het akkoord wordt nog opgeslagen
       en het slotje verdwijnt zo vanzelf. */
    if (!checkbox.checked) remind(container, CONFIG.messages.required);
  }

  document.addEventListener(
    'click',
    function (event) {
      var trigger = closest(event.target, '[name="checkout"], ' + SHIELD);
      if (trigger) guard(event, trigger);
    },
    true
  );

  /* Enter in een aantalveld verstuurt het formulier ook via de afrekenknop. */
  document.addEventListener(
    'submit',
    function (event) {
      var submitter = event.submitter;
      if (submitter && submitter.name === 'checkout') guard(event, submitter);
    },
    true
  );

  /* Het thema bouwt de winkelwagen na elke wijziging opnieuw op vanuit de server. Die stand
     klopt met het opgeslagen kenmerk, behalve als er op dat moment nog een opslag onderweg was:
     zet nieuw verschenen vinkjes en slotjes daarom gelijk aan de laatste keuze. */
  var WATCHED = CHECKBOX + ', ' + GATE;
  new MutationObserver(function (mutations) {
    if (!state) return;

    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var node = added[j];
        if (node.nodeType !== 1) continue;
        if (node.matches(WATCHED) || node.querySelector(WATCHED)) {
          apply();
          return;
        }
      }
    }
  }).observe(document.body, { childList: true, subtree: true });
})();
